import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { useState } from 'react';

const RoomCard = ({ room }) => {
  const [open, setOpen] = useState(false);

  const visibleGroups = room.groups?.slice(0, 5) || [];
  const remaining = room.groups?.length > 5 ? room.groups.length - 5 : 0;

  return (
    <>
      <Card
        className="bg-muted dark:bg-background flex flex-col cursor-pointer hover:shadow-md transition"
        onClick={() => setOpen(true)}
      >
        <div className="p-4 grow space-y-3 lg:space-y-4">
          <div className="flex items-center justify-between">
            <h2 className="text-lg lg:text-xl font-semibold">{room.name}</h2>
            <DropdownMenu>
              <DropdownMenuTrigger asChild aria-hidden="true">
                <Button
                  variant="ghost"
                  className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
                  onClick={(e) => e.stopPropagation()} // 🔹 Sheet ochilishini to‘xtatamiz
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="currentColor"
                    className="h-5 w-5"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
                    />
                  </svg>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-[160px]">
                <DropdownMenuItem
                  onSelect={() => {
                    document.body.style.pointerEvents = '';
                  }}
                >
                  Tahrirlash
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  onSelect={() => {
                    document.body.style.pointerEvents = '';
                  }}
                >
                  O'chirish
                  <DropdownMenuShortcut>⌘⌫</DropdownMenuShortcut>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>

          {/* Guruhlar avatar preview */}
          <div className="flex items-center -space-x-2.5">
            {visibleGroups.map((g, i) => (
              <Avatar key={i} className="w-7 h-7 shadow border border-border">
                <AvatarImage src={g.image} />
                <AvatarFallback className="text-xs bg-white dark:bg-muted">
                  {g.name?.slice(0, 2).toUpperCase()}
                </AvatarFallback>
              </Avatar>
            ))}
            {remaining > 0 && (
              <div className="w-7 h-7 flex items-center justify-center rounded-full border border-border bg-muted text-xs font-medium">
                +{remaining}
              </div>
            )}
          </div>

          <div className="flex flex-wrap gap-2">
            <Badge className="text-sm font-medium" variant="secondary">
              Sig‘imi: {room.capacity || "noma'lum"} kishi
            </Badge>
          </div>
        </div>

        <div className="flex items-center justify-between py-3 px-4 border-t border-border">
          <span className="text-sm text-muted-foreground">
            Qo'shilgan vaqt: 05.09.2025
          </span>
        </div>
      </Card>

      {/* 🔹 Sheet */}
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent>
          <SheetHeader>
            <SheetTitle className="flex items-center gap-2">
              <span>{room.name}</span>

              <Badge>Sig‘imi: {room.capacity} ta</Badge>
            </SheetTitle>
            <SheetDescription>Yaralgan: 22.09.2025</SheetDescription>
          </SheetHeader>

          <div className="mt-4 space-y-2">
            <h3 className="font-semibold">Biriktirilgan guruhlar</h3>
            {room.groups?.length > 0 ? (
              <ul className="space-y-2">
                {room.groups.map((g) => (
                  <li
                    key={g.id}
                    className="flex justify-between items-center border py-2 px-4 rounded-xl bg-muted dark:bg-background"
                  >
                    <div>
                      <p className="font-medium">{g.name}</p>
                      <p className="text-xs text-muted-foreground">
                        {g.day} | {g.startTime} - {g.endTime}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-sm text-muted-foreground">
                Hozircha guruhlar biriktirilmagan.
              </p>
            )}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};

export default RoomCard;
